import Vue from 'vue'
import Vuex from 'vuex'


import state from './state'
import mutations from './mutations'
//import mutations from './mutations'
Vue.use(Vuex)



const store = new Vuex.Store({
	state,
	mutations
});

export default store


// WEBPACK FOOTER //
// ./src/store/index.js